import styled from 'styled-components';
import SecureInboxSummary from '../../../components/individualPortal/secureInbox/subComponents/SecureInboxSummary';

export const ContactAndFAQContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #DDDDE5;
  padding-right: 40px;
`;

export const ContactAndFAQLink = styled.a`
  &:nth-child(1) {
   margin-right: 15px;
  }
  // color: #91350a!important;
  font-weight: 600;
 
`;

export const InboxNoticesStyled = styled(SecureInboxSummary)`
    width: 100%;
    table th:last-child, td:last-child {
        text-align: center;
    }
    .inbox__title {
        display: inline-block;
        margin-right: 20px;
    }
    .inbox__cnt-items {
        display: inline-block;
    }
    .fa-paperclip {
        // color: #91350a;
    }
`;
